import React from 'react';
import moment from 'moment';
import { dateTimeFormat } from '@gik/core/utils/DateTimeUtils';
import useViewFeaturedPageAnalytics from './useViewFeaturedPageAnalytics';
import useCompletedPurchaseForPageAnalytics from './useCompletedPurchaseForPageAnalytics';
import useCreatePageFinishedAnalytics from './useCreatePageFinishedAnalytics';
import { markFirstLandedGIKPage } from '@gik/core/utils/Tracking';

const inkindPageViewHistoryKey = 'inkind-page-view-history';

export interface PageViewHistoryItem {
  numVisits: number;
  lastVisit: string;
  firstVisit: string;
}

export interface InkindPageViewHistoryItem extends PageViewHistoryItem {
  inkindRouteId: string;
}

interface InkindPageViewRecorderProps {
  inkindRouteId: string;
}

export function getInkindPageViewHistory(): InkindPageViewHistoryItem[] {
  const serializedInkindViewHistory = localStorage.getItem(inkindPageViewHistoryKey);
  return serializedInkindViewHistory ? JSON.parse(serializedInkindViewHistory) : [];
}

// TODO: convert this into a hook
export default function InkindPageViewRecorder({ inkindRouteId }: InkindPageViewRecorderProps): React.ReactElement {
  markFirstLandedGIKPage(inkindRouteId);
  useViewFeaturedPageAnalytics();
  useCompletedPurchaseForPageAnalytics();
  useCreatePageFinishedAnalytics();

  const inkindViewHistory: InkindPageViewHistoryItem[] = getInkindPageViewHistory();

  const now = moment().format(dateTimeFormat);
  const createNewInkindPageViewHistoryItem = (): InkindPageViewHistoryItem => ({
    firstVisit: now,
    lastVisit: now,
    inkindRouteId,
    numVisits: 1,
  });

  const currentItem = inkindViewHistory.find(item => item.inkindRouteId === inkindRouteId);
  if (!currentItem) {
    inkindViewHistory.push(createNewInkindPageViewHistoryItem());
  } else {
    currentItem.numVisits++;
    currentItem.lastVisit = now;
  }

  inkindViewHistory.sort((a, b) =>
    moment(a.lastVisit, dateTimeFormat).isAfter(moment(b.lastVisit, dateTimeFormat)) ? -1 : 1
  );
  localStorage.setItem(inkindPageViewHistoryKey, JSON.stringify(inkindViewHistory));
  return null;
}
